// StackedColumnChart Component
import React, { useState, forwardRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../components/Common/ChartsDynamicColor";

const StackedColumnChart = forwardRef(({ dataColors, periodData }, ref) => {
  const stackedColumnChartColors = getChartColorsArray(dataColors);

  const [chartOptions, setChartOptions] = useState({
    chart: {
      stacked: true,
      toolbar: { show: false },
      zoom: { enabled: true },
    },
    plotOptions: { bar: { horizontal: false, columnWidth: "15%" } },
    dataLabels: { enabled: false },
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      // categories: periodData?.map(c => c.Day) || [],
      labels: { show: true },
    },
    colors: stackedColumnChartColors,
    legend: { position: "bottom" },
    fill: { opacity: 1 },
  });

  useImperativeHandle(ref, () => ({
    updateChartOptions: (categories) => {
      setChartOptions((prevOptions) => ({
        ...prevOptions,
        xaxis: { ...prevOptions.xaxis, categories },
      }));
    },
  }));

  return (
    <React.Fragment>
      <ReactApexChart
        options={chartOptions}
        series={[...periodData]}
        // series={[{name: 'COUNT',  data: periodData?.map(d=> d.Count) || []}]}
        type="bar"
        height="359"
        className="apex-charts"
      />
    </React.Fragment>
  );
});

// Set display name for the component
StackedColumnChart.displayName = "StackedColumnChart";

StackedColumnChart.propTypes = {
  dataColors: PropTypes.string,
  periodData: PropTypes.any,
};

export default StackedColumnChart;
